export default class Reg {
  public static mobile = /^1\d{10}$/;
  public static password = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,32}$/;
  public static email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  public static numberReg = /^d+$/;

  public static isMobile(s: string): boolean {
    return Reg.mobile.test(s);
  }

  public static isPassword(s: string): boolean {
    return Reg.password.test(s);
  }

  public static isEmail(s: string): boolean {
    return Reg.email.test(s);
  }

  public static isNumber(s: string): boolean {
    return Reg.numberReg.test(s);
  }
}
